import { http } from '../../../api/http-common';

const list = (success, fail, query) => {
  http
    .get('subprocess' + (query?('?q='+query) : ''))
    .then((response) => success(response))
    .catch((response) => fail(response));
};

export { list}; 